import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "@/App";

import TestPage from "@/pages/testPage";
import AiMarketplaceLayout from "@/components/layout/AiMarketplaceLayout";
import VideoDashboard from "@/pages/VideoDashboard/VideoDashboard";
import ProductCollections from "@/pages/ProductCollections/ProductCollections";
import ProductStructure from "@/pages/ProductStructure/ProductStructure";
import SelectVideo from "@/pages/SelectVideo/SelectVideo";
import VideoComparison from "@/pages/VideoComparison/VideoComparison";
import VerifyUser from "@/pages/verifyAuth/verifyUser";
import ProtectedRoute from "./ProtectedRoute";
import ComingSoon from "@/pages/commingSoon/CommingSoon";
import Products from "@/pages/Products/Products";
import BrandCartDetails from "@/pages/BrandCartDetails/BrandCartDetails";
import AiPricing from "@/pages/aiPricing/aiPricing";

export const router = createBrowserRouter(
  [
    {
      path: "test-page",
      element: <TestPage />,
    },
    {
      path: "auth/verify",
      element: <VerifyUser />,
    },

    {
      path: "/",
      element: (
        <ProtectedRoute>
          <AiMarketplaceLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          index: true,
          element: <VideoDashboard />,
        },
        {
          path: "brand-cart-details/:brandName",
          element: <BrandCartDetails />,
        },
        {
          path: "products",
          element: <Products />,
        },
        {
          path: "product-collections/:productId/:brandName/:productName/:country",
          element: <ProductCollections />,
        },
        {
          path: "product-structure/:productId/:brandName/:productName/:persona/:country",
          element: <ProductStructure />,
        },
        {
          path: "select-video/:productId/:brandName/:productName",
          element: <ComingSoon />,
        },
        {
          path: "video-comparison/:productId",
          element: <VideoComparison />,
        },
        {
          path: "pricing",
          element: <AiPricing />,
        },
      ],
    },
  ],
  {
    basename: "/ai-intelligence",
  }
);
